import { Arrow } from '../../../svg';
import { formatPercent } from '@/utils/numberUtils';

interface Props {
  percent: string | number;
  className?: string;
}
const IndicateUp: React.FC<Props> = ({ percent, className }) => {
  const display =
    typeof percent === 'number' ? formatPercent(percent) : `${percent}%`;
  return (
    <span
      className={`flex items-center justify-center bg-[#E6F8F0] rounded-full px-2 py-1 gap-[2px] ${className ? className : ''}`}
    >
      <span className="text-xs text-[#00AE3E] font-medium font-[Inter] leading-4">
        {display}
      </span>
      <img
        src="/assets/trending-up-green.svg"
        alt="arrow"
        className="w-[8px] h-[16px"
      />
    </span>
  );
};

export default IndicateUp;
